module.exports = __webpack_public_path__ + "img/position-lost-bg.56f99beb.png";